import { render, staticRenderFns } from "./btn-text-tertiary2.vue?vue&type=template&id=1b6d85f2&scoped=true&"
import script from "./btn-text-tertiary2.vue?vue&type=script&lang=js&"
export * from "./btn-text-tertiary2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6d85f2",
  null
  
)

export default component.exports